export const SPECIALS = {
  CME: "Corps of the Mossos d'Esquadra",
  DGP: "Spanish Police",
  CNP: "Spanish Police",
  E: "Autonomous police force of the Basque Country",
  EA: "Air Force",
  ET: "Spanish Army",
  FAE: "Allied Forces in Spain",
  FN: "Spanish Navy",
  GSH: "Colonial police on Sahara",
  PGC: "Spanish civil guard",
  MF: "Public Works Ministry",
  MMA: "Environment Ministry",
  MOP: "Public Works Ministry",
  PME: "State owned vehicles",
  PMM: "State owned vehicles, on a Ministry",
  CROWN: "King's Car"
};
